import React from 'react';

import { Stack, Typography } from '@mui/material';
import BlockTypeIcon from '@wp-block-builder/blocks/helpers/BlockTypeIcon';

import { type TFlatBlock } from './helpers/blocksToFlatDocument';

type Props = {
  flatBlock: TFlatBlock;
  selected?: boolean;
};

export default function BlockViewLabel({ selected, flatBlock }: Props) {
  const textColor = selected ? 'white' : 'text.secondary';
  return (
    <Stack alignItems="center" direction="row" spacing={0.75} sx={{ color: textColor }}>
      <BlockTypeIcon sx={{ fontSize: 16, color: 'inherit' }} type={flatBlock.block.type} />
      <Typography variant="body2">{getTypeLabel(flatBlock)}</Typography>
    </Stack>
  );
}

function getTypeLabel(flatBlock: TFlatBlock) {
  switch (flatBlock.block.type) {
    case 'ColumnsSection':
      return 'Columns';
    case 'ContainerYield':
      return 'Template';
    case 'LoopContainer':
      return 'Loop';
    case 'ProgressBar':
      return 'Progress bar';
    case 'Avatar':
    case 'Button':
    case 'Container':
    case 'Divider':
    case 'Heading':
    case 'Html':
    case 'Image':
    case 'Spacer':
    case 'Text':
      return flatBlock.block.type;
  }
}
